import type { WalletSchema } from '../../legacyWalletBook.types';

/**
 * Embedded wallet keys that should be filtered out from the WalletConnect catalog.
 * These wallets are not meant to be displayed in wallet selection lists.
 */
export const EMBEDDED_WALLET_KEYS = [
  'magicemailotp',
  'magiclink',
  'magicsocial',
  'turnkey',
  'turnkeyhd',
  'zerodev',
  'dynamicwaas',
  'coinbasempc',
  'mpcvault',
  'mpcwallet',
];

/**
 * Checks if a wallet should be filtered out from the WalletConnect catalog.
 *
 * @param walletKey - The wallet key identifier.
 * @param wallet - The wallet schema to check.
 * @returns True if the wallet should be filtered out, false otherwise.
 */
export const shouldFilterWallet = (
  walletKey: string,
  wallet: WalletSchema
): boolean => {
  // Filter out embedded wallets
  if (EMBEDDED_WALLET_KEYS.includes(walletKey)) {
    return true;
  }

  // Filter out wallets that don't support WalletConnect sign_v2
  if (!wallet.walletConnect || !wallet.walletConnect.sdks.includes('sign_v2')) {
    return true;
  }

  // Filter out wallets that are only injected (have injectedConfig but no mobile/desktop links)
  const hasInjectedConfig =
    wallet.injectedConfig && wallet.injectedConfig.length > 0;
  const hasMobileLinks = Boolean(
    wallet.mobile?.androidId ||
      wallet.mobile?.iosId ||
      wallet.mobile?.native ||
      wallet.mobile?.universal
  );
  const hasDesktopLinks = Boolean(
    wallet.desktop?.chromeId ||
      wallet.desktop?.edgeId ||
      wallet.desktop?.firefoxId ||
      wallet.desktop?.operaId ||
      wallet.desktop?.safariId ||
      wallet.desktop?.universal
  );

  if (hasInjectedConfig && !hasMobileLinks && !hasDesktopLinks) {
    return true;
  }

  return false;
};
